import { render } from "./information.vue?vue&type=template&id=719d2abb&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"

import "./information.vue?vue&type=style&index=0&id=719d2abb&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719d2abb"]])

export default __exports__